import { Box, Card, CardContent, Chip, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const NetworkInfluencerCard = ({ networkList, selectedStartDate }) => {
  const navigate = useNavigate();
  const handleShowDetails = (network_id, beneficiary_esi_id) => {
      navigate('/benefits/network-influencer', {
          state: {
              network_id: network_id,
              selectedDate: selectedStartDate ? selectedStartDate : null,
              beneficiary_esi_id: beneficiary_esi_id
          },
      });
  };
  return (
    <Box>
          {networkList && networkList.length > 0 ? (
            networkList.map((gift, index) => {
              return (
                <Card
                  key={index}
                  sx={{
                    cursor: 'pointer',
                    mb: 2,
                    borderRadius: '12px',
                    boxShadow:
                      '0 0 2px 0 rgba(145, 158, 171, 0.5), 0 12px 24px -4px rgba(145, 158, 171, 0.12)',
                  }}
                  onClick={() => handleShowDetails(gift.id, gift.beneficiary_esi_id)}
                >
                  <CardContent
                    sx={{ display: 'flex', justifyContent: 'space-between' }}
                  >
                    <Box sx={{ pr: 1, width: '80%' }}>
                      <Typography
                        variant='body2'
                        sx={{ fontWeight: 'bold' }}
                      >
                        Network Name : {gift.beneficiary_name}
                      </Typography>
                      <Typography
                        variant='body2'
                        sx={{}}
                      >
                        Active Influencer : {gift.active_influencer}
                      </Typography>
                      <Typography
                        variant='body2'
                        sx={{}}
                      >
                        Reward Announced : {gift.reward_announced}
                      </Typography>

                      <Typography variant='body2'>
                        Phone: {gift.beneficiary_phone}
                      </Typography>
                      <Typography variant='body2'>
                        Role : {gift.beneficiary_role}
                      </Typography>
                    </Box>
                    <Box sx={{width: '25%'}}>
                      <Typography variant='body2'>
                        {gift.last_announced}
                      </Typography>
                    </Box>
                  </CardContent>
                </Card>
              );
            })
          ) : (
            <Typography align='center'>No data available</Typography>
          )}
        </Box>
  )
}

export default NetworkInfluencerCard